// @ts-ignore
import Geocode from "react-geocode";
import { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";

if (process.env.REACT_APP_GOOGLE_MAP_KEY) {
  Geocode?.setApiKey(process.env.REACT_APP_GOOGLE_MAP_KEY);
}

export function useAddress() {
  const getAddressComponent = (addressArray: any, componentType: any) => {
    let state = "";
    for (let j = 0; j < addressArray.length; j++) {
      if (addressArray[j].types[0] && addressArray[j].types[0] === componentType) {
        state = addressArray[j].long_name;
        return state;
      }
    }
    return state;
  };

  const handleNewLocation = async (address: string) => {
    try {
      const results = await geocodeByAddress(address);
      const { lat, lng } = await getLatLng(results[0]);

      const response = await Geocode?.fromLatLng(lat, lng);


      const addressArray =results[0]?.address_components;

      const newAddress = {
        streetAddress: "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        locality: ""
      };
      newAddress.city = getAddressComponent(addressArray, "administrative_area_level_2");
      const locality = getAddressComponent(addressArray, "locality");
      newAddress.locality = locality;
      const [streetAddress] = response.results[0].formatted_address.split(",");

      //check street
      newAddress.streetAddress = streetAddress.replace(/,\s*$/, "");
      newAddress.state = getAddressComponent(addressArray, "administrative_area_level_1");
      newAddress.country = getAddressComponent(addressArray, "country");
      newAddress.postalCode = getAddressComponent(addressArray, "postal_code");
      return newAddress;
    } catch (error) {
      console.error("error", error);
    }
  };

  return {
    handleNewLocation
  };
}
